import React from 'react'
import AdvertiserForm from 'pages/ArcAdvertisers/AdvertiserForm'
import useAction from 'utils/useAction'
import * as actions from 'actions/views/arcAdvertisers'

const ArcAdvertiserModal = ({ closeModal, ...data }) => {
  const fetchAdvertisers = useAction(actions.fetchArcAdvertisers)

  const handleSuccess = () => {
    fetchAdvertisers({ page: 1, search: '', filters: {}, sorter: {} })
    closeModal()
  }

  const handleCancel = () => {
    closeModal()
  }

  return (
    <AdvertiserForm
      advertiserId={data?.id || null}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
    />
  )
}

export default ArcAdvertiserModal
